/* Koleksiyon / arama hero — 3 görsel rastgele başlangıç + softfade */
(function () {
  function initHero(el) {
    var slides = el.querySelectorAll('.wardah-urunler-hero__slide');
    if (!slides.length) return;

    var n = slides.length;
    var start = Math.floor(Math.random() * n);
    var current = start;
    var interval = parseInt(el.getAttribute('data-hero-interval') || '7000', 10);
    if (isNaN(interval) || interval < 3000) interval = 7000;

    slides.forEach(function (s, i) {
      s.classList.toggle('is-active', i === current);
    });

    if (n < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    setInterval(function () {
      slides[current].classList.remove('is-active');
      current = (current + 1) % n;
      slides[current].classList.add('is-active');
    }, interval);
  }

  function boot() {
    document.querySelectorAll('[data-hero-rotate]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
